document.addEventListener("DOMContentLoaded", function () {

  /* =============================
     MARQUEE FIX
  ============================== */

  document.querySelectorAll(".Index_object_testimonials_marquee").forEach((marquee) => {

    if (marquee.dataset.duplicated === "true") return;
    marquee.dataset.duplicated = "true";

    const content = marquee.querySelector("span");
    if (!content) return;

    const clone = content.cloneNode(true);
    marquee.appendChild(clone);

    marquee.classList.add("marquee-active");
  });


  /* =============================
     VIDEO MUTE / UNMUTE
  ============================== */

  document.querySelectorAll(".video_play_list").forEach((playlist) => {

    playlist.querySelectorAll(".mute_video").forEach((btn) => {
      btn.addEventListener("click", function () {
        const parent = btn.closest(".full_video_new");
        const video = parent.querySelector("video");

        video.muted = true;

        parent.querySelector(".mute_video").classList.remove("active");
        parent.querySelector(".unmute_video").classList.add("active");
      });
    });

    playlist.querySelectorAll(".unmute_video").forEach((btn) => {
      btn.addEventListener("click", function () {

        // mute all
        playlist.querySelectorAll("video").forEach(v => v.muted = true);

        playlist.querySelectorAll(".full_video_new").forEach((box) => {
          box.querySelector(".mute_video").classList.remove("active");
          box.querySelector(".unmute_video").classList.add("active");
        });

        const parent = btn.closest(".full_video_new");
        const video = parent.querySelector("video");

        video.muted = false;

        parent.querySelector(".unmute_video").classList.remove("active");
        parent.querySelector(".mute_video").classList.add("active");
      });
    });

  });

});
